import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import InnerPage from '../components/InnerPage.jsx';
import PhotoGallery from '../components/PhotoGallery.jsx';
import { EVENT_PHOTOS } from '../data/eventPhotos.js';

export default function EventsPage() {
  useEffect(() => {
    document.title = 'Events | Nouakchott Oumtounsy International Airport (NKC/GQNO)';
  }, []);

  return (
    <InnerPage
      slug="events"
      heading="Events"
      lead="Conferences, forums, and moments from life at NKC."
      banner="/images/events/event (1).jpg"
      section="experience"
    >
      <section className="section inner-content">
        <div className="container inner-prose">
          <p className="inner-lead">
            From aviation forums and industry panels to public programmes at the terminal, browse
            highlights from recent events at Nouakchott Oumtounsy International Airport (NKC/GQNO).
          </p>

          <section className="inner-block" aria-labelledby="ev-gallery">
            <h2 id="ev-gallery">Event gallery</h2>
            <p>Click any photo to open a larger view and slide through the full set.</p>

            <PhotoGallery
              photos={EVENT_PHOTOS}
              gridClass="gallery-grid gallery-grid--events"
              galleryId="eventsGallery"
              emptyNote="Event photos will appear here when available."
              openLabel={(i, total) => `Open event photo ${i + 1} of ${total}`}
              lightboxLabel="Event photo viewer"
            />
          </section>

          <section className="inner-block" aria-labelledby="ev1">
            <h2 id="ev1">Stay informed</h2>
            <p>
              Follow <Link to="/news">airport news</Link> for upcoming dates and programmes. To host
              an event at the airport, see <Link to="/plan-events">plan your events</Link>.
            </p>
          </section>

          <p className="inner-disclaimer" role="note">
            Airport and flight information on this website is provided for general guidance only and
            may change without notice. While Nouakchott Oumtounsy International Airport (NKC/GQNO)
            strives to keep content accurate and up to date, information may occasionally be
            incomplete, outdated, or incorrect. Always confirm flight schedules, check-in times,
            baggage allowances, facilities, services, and other travel requirements with your airline
            or the relevant authority before travelling. Entry, visa, customs, and health requirements
            should be verified with the relevant government authorities. Where flight times are shown,
            they are in <abbr title="Greenwich Mean Time">GMT</abbr> (Nouakchott).
          </p>
        </div>
      </section>
    </InnerPage>
  );
}
